export const useUrlHashStore = () => {
  const hash = useState<string>('hash', () => '');

  const setHash = (value: string) => {
    hash.value = value;
  }

  const removeHash = () => {
    hash.value = '';
  }

  return {
    hash,
    setHash,
    removeHash,
  };
}